import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollPositionService {
  private positions: { [url: string]: number } = {};
  private _postId: string | undefined;
  private _listItemId: string | undefined;

  getPostId(): string {
    return this._postId;
  }

  setPostId(value: string | undefined) {
    this._postId = value;
  }

  getListItemId(): string {
    return this._listItemId;
  }

  setListItemId(value: string | undefined) {
    this._listItemId = value;
  }

  setScrollPosition(url: string, position: number) {
    this.positions[url] = position;
  }

  getScrollPosition(url: string): number {
    return this.positions[url] || 0;
  }
}
